export default {
  product: {
    tabName1: "By Product",
    tabName2: "By Scenario",
    tabName3: "By Industry",
  },
  home: {
    news: "New Media",
    tip1: "Please enter keywords",
    tip2: "Start Date",
    tip3: "End Date",
    tip4: "Views",


    title: "HHDlink",
    home: "Home",
    product: "Products",
    sulotion: "Applications",
    us: "About us",
    // news:"News",
    bo: "BBS",
    search: "Search",
    yingwen: "English",
    zhongwen: "Chinese",
    denglu: "Login",
    gengduo: "Read more",
    xhanp: "Detail",
    banner: "Carousel",
    lx: "Contact us",
    fa: "Applications detail",
    xw: "News detail",
    noResult: "No results found. Try a different search?",
    resultNum: "We found 0 results for your search.",
    tip: 'Services',
    case: "Cases",
    more: "Read more"
  },
  my: {
    cptp: "Product photos",
    cpmz: "Product name",
    sl: "Quantity",
    placeholder: 'Please  enter content',
    placeholder1: 'Please  enter your name',
    placeholder2: 'Please  enter your email',
    placeholder3: 'Please enter company name',
    placeholder4: 'Please i enter contact number',
    placeholder5: 'Leave message',
    placeholder6: 'Please enter the correct email address',
    mz: "Name",
    email: "Email",
    gsmz: "Company name",
    dh: "Phone number",
    ly: "Leave a message",
    tj: "Submit",
    tip: "Submit successfully",
    tai: "Piece",
    cpzx: "Product consulting",
    searchR: "Search results",
    pre: "Previous",
    next: "Next",
    address: '© SHENZHEN HHD TECHNOLOGY CO., LTD Copyright 2016-2021  ',
    currentL: "Current Location"
  },
  media: {
    tip1: "Please enter the solution details",
    tip2: "Please enter the main title",
    tip3: "Please enter the subtitle",
    tip4: "Solution Background",
    tip5: "Please enter the solution background",
    tip6: "Product Introduction",
    tip7: "Title",
    tip8: "Please enter the title",
    tip9: "Please select the product name",
    tip10: "Please enter the product description",
    tip11: "View Details",
    tip12: "Solution Highlights",
    tip13: "Please enter the solution advantages/highlight title",
    tip14: "Please enter the solution advantages/highlight description",
    tip15: "Product Recommendation",
    tip16: "Please upload the top image of the solution details",
    tip17: "Please enter the main title",
    tip18: "Please enter the subtitle",
    tip19: "Please upload the product introduction image",
    tip20: "Please enter the product introduction title",
    tip21: "Please select the product model for the product introduction",
    tip22: "Please select the product name for the product introduction",
    tip23: "Please enter the product description for the product introduction",
    tip24: "Please complete the solution highlights content",
    tip25: "At least one product recommendation must be provided",
    tip26: "Product recommendation image cannot be empty",
    tip27: "Product recommendation name cannot be empty",
    tip28: "At least one product introduction must be provided",
    tip29: "Website Entry",
    tip30: "Partner Showcase",
    tip31: "Partnership Application",
    tip32: "Your Name",
    tip33: "Your Phone Number",
    tip34: "Email Address",
    tip35: "Company Name",
    tip36: "Please fill in your requirements",
    tip37: "Please enter your name",
    tip38: "Please enter your phone number",
    tip39: "Please enter your email address",
    tip40: "Please enter your company name",
    tip41: "Submit",
    tip42:"Submit successful.",
    tip43:"Only numeric input allowed.",
    tip44:"Incorrect email format",
    tip45:"System"
  },
  production: {
    chanpinxinghao: 'Product Name',
    placeholder: 'Please enter the product name',
    chanpinleixing: 'Product Type',
    placeholder1: 'Please select the product type',
  }
}


// WEBPACK FOOTER //
// ./src/i18n/lang/en.js